/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Col_DeckInputs */



/**
* | output |
* | --- |
* | "Deck" |
*
* @param {Tournament_Col_DeckInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_col_deck = /** @type {((inputs?: Tournament_Col_DeckInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Col_DeckInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deck")
	if (locale === "es") return /** @type {LocalizedString} */ ("Deck")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Deck")
	if (locale === "it") return /** @type {LocalizedString} */ ("Deck")
	return /** @type {LocalizedString} */ ("Deck")
});